import { FC, useEffect, useState } from 'react';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { useSlideout } from '../../../../hooks/use-slideout';
import { EventApptRequestsWidget } from '../../../../types/event-bus';
import { ApptRequestsWidgetComponent } from './appt-requests-widget';
import { ApptRequestsIvProvider } from './hooks/use-appt-requests-iv';
import { ApptRequestsWidgetProvider } from './hooks/use-appt-requests-widget';

const ApptRequestsWidgetWithProvider: FC = () => {
  const { listen } = useEventBus();
  const { currentEvent } = useSlideout();
  const [widgetEvent, setWidgetEvent] = useState<EventApptRequestsWidget>();

  useEffect(() => {
    if (currentEvent?.messageType === 'appt-requests-widget') {
      resetWidget();
      setTimeout(() => setWidgetEvent(currentEvent as EventApptRequestsWidget), 0);
    }
  }, [currentEvent]);

  useEffect(() => {
    const listener = listen('closeWidget', (event) => {
      if (event.messageType === 'closeWidget') resetWidget();
    });

    return () => listener();
  }, [listen]);

  const resetWidget = () => {
    setWidgetEvent(undefined);
  };

  return widgetEvent ? (
    <ApptRequestsWidgetProvider widgetEvent={widgetEvent}>
      <ApptRequestsIvProvider>
        <ApptRequestsWidgetComponent />
      </ApptRequestsIvProvider>
    </ApptRequestsWidgetProvider>
  ) : null;
};

export const ApptRequestsWidget = ApptRequestsWidgetWithProvider;
